import { render, staticRenderFns } from "./vehicle_deliveries.vue?vue&type=template&id=96e67a2a&"
import script from "./vehicle_deliveries.vue?vue&type=script&lang=js&"
export * from "./vehicle_deliveries.vue?vue&type=script&lang=js&"
import style0 from "./vehicle_deliveries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports